<template>
  <single-page hide-sidebar>
    <template v-slot:toolbar-title>
      {{ $route.name }}
    </template>
    <template v-slot:toolbar-items>
      <print-pdf-button id-to-print="event-table-to-print"
                        :page-title="$route.name+' '+projectDetails.ProjectName+' '+branch(projectDetails.Branch_ID).BranchAddress">
      </print-pdf-button>
    </template>
    <template v-slot:main-content>
      <event-list :events="events"></event-list>
    </template>
  </single-page>
</template>

<script>
import {mapGetters} from "vuex";
import EventList from "@/views/Events/components/EventList";
import projectMixin from "@/views/Projects/mixins/projectMixin";
import SinglePage from "@/components/templates/SinglePage";
import PrintPdfButton from "@/components/PrintPdfButton";

export default {
  name: "ProjectEvents",
  components: {PrintPdfButton, SinglePage, EventList},
  mixins: [projectMixin],
  data: () => ({}),
  computed: {
    ...mapGetters([
      'isMobile'
    ]),
    events() {
      if (this.type) {
        return this.projectEvents.filter(e => e.EventType_ID === this.type)
      } else {
        return this.projectEvents
      }
    }
  },
  watch: {
    type() {
      this.getProjectEvents();
    }
  },
  created() {
    this.getProjectEvents();
  },


  props: {
    type: {type: Number, default: null, required: false}
  }
}
</script>

<style scoped>

</style>
